import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import {loader, toastr} from '../CommonActions';
import { auth} from '../../../services';

export const GET_COMMITTEE_MEMBERS = 'GET_COMMITTEE_MEMBERS';
export const ADD_COMMITTEE_MEMBER = 'ADD_COMMITTEE_MEMBER';
export const DELETE_COMMITTEE_MEMBER = 'DELETE_COMMITTEE_MEMBER';
export const GET_POSITIONS_BYGROUP = 'GET_POSITIONS_BYGROUP';

const successColor =  "success";
const errorColor = "danger";
const warningColor = "warning";

export function fetchCommitteesMembers(committeeId) {
	return async function(dispatch) {
		dispatch(loader(true));
		await axios
				.get(`${ROOT_API_URL}/ManageCommitteeMember/GetCommitteeMembers?committeeId=${committeeId}`, { headers: auth.authHeader() })
				.then((response) => {
					dispatch({
						type: GET_COMMITTEE_MEMBERS,
						payload: response.data.committeeMembers,
					});
					dispatch(loader(false));
				})
				.catch((error) => {
					var err = "Network Connection Error"; 
					dispatch(loader(false));		
					dispatch(toastr(true,err, errorColor));
				});
	};
}

export function fetchCommitteesMembersByCommitteeMemberId(committeeMemberId) {
	return function (dispatch) {
		dispatch(loader(true));
		axios
			.get(`${ROOT_API_URL}/ManageCommitteeMember/GetCommitteeMembersByMemberId?committeeMemberId=${committeeMemberId}`, { headers: auth.authHeader() })
			.then((response) => {
				dispatch({
					type: GET_COMMITTEE_MEMBERS,
					payload: response.data.committeeMembers,
				});
				dispatch(loader(false));
			})
			.catch((error) => {
				var err = "Network Connection Error";
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}

export function fetchPositionsByPositionGroup(positionGroupId) {
	return function(dispatch) {
		dispatch(loader(true));

		var url = `${ROOT_API_URL}/ManagePosition/GetPositionByPositionGroup?positionGroupId=${positionGroupId}`;
		const options = { method: 'GET', headers: auth.authHeader() };
		axios.get(url, options).then(function(response) {
				dispatch({
					type: GET_POSITIONS_BYGROUP,
					payload: response.data
				});
				dispatch(loader(false));
			})
			.catch((error) => {
				var err = "Network Connection Error"; 
				dispatch(loader(false));		
				dispatch(toastr(true,err, errorColor));
			});
	};
}

export function addCommitteeMember(model) {
	return async function(dispatch) {
		dispatch(loader(true));
		await axios
				.post(`${ROOT_API_URL}/ManageCommitteeMember/AddCommitteeMember`, model, { headers: auth.authHeader() })
				.then(function(response){	
					if (response && response.data && response.data.issuccess) 
					{
						dispatch({
							type: ADD_COMMITTEE_MEMBER,
							payload: response.data.committeeMembers,
						});
						var success = response && response.data ? response.data.message : "Committee Member Created Successfully"; 
						dispatch(toastr(true,success, successColor));
					}
					else {
						var err = response && response.data ? response.data.message : "Committee Member Already Exists"; 
						dispatch(toastr(true,err, warningColor));
					}
					dispatch(loader(false));
				})
				.catch((response) => {
					var err = response && response.data ? response.data.message : "Network Connection Error"; 
					dispatch(loader(false));		
					dispatch(toastr(true,err, errorColor));
				});
	};
}

export function deleteCommitteeMember(model) {

	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManageCommitteeMember/DeleteCommitteeMember`, model, { headers: auth.authHeader() })
			.then((response) =>
			{
			if (response && response.data && response.data.issuccess) 
				{
					dispatch({
						type: DELETE_COMMITTEE_MEMBER,
						payload: response.data.committeeMembers
					});	
					var success = response && response.data ? response.data.message : "Committee Member Deleted Successfully"; 
					dispatch(toastr(true,success, successColor));
				}
				else {
					var err = response && response.data ? response.data.message : "Error Occured"; 
					dispatch(toastr(true,err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				dispatch(loader(false));

				var err = response && response.data ? response.data.message : "Network Connection Error"; 
				dispatch(toastr(true,err, errorColor));
			});
	};
}